/* eslint-disable no-console */
import { ICache, ICacheResult } from '../types';
import { toJson, toString } from './utils';

export class SessionStorage implements ICache {
  private session;
  private defaultEmpty = '{}';
  private ResolveSuccess: ICacheResult<any> = { success: true };

  constructor() {
    if (!window.sessionStorage) {
      throw Error('The browser does not support window.sessionStorage');
    }
    this.session = window.sessionStorage;
  }

  async upsert<T>(key: string, value: any): Promise<ICacheResult<T>> {
    this.session.setItem(key, toString(value, this.defaultEmpty));
    return Promise.resolve({ ...this.ResolveSuccess, data: { key, value } as T });
  }

  async get<T>(key: string): Promise<ICacheResult<T>> {
    const strValue = this.session.getItem(key) || this.defaultEmpty;
    const value: T = toJson(strValue, {});
    return Promise.resolve({ ...this.ResolveSuccess, data: value });
  }

  close?: (() => void) | undefined;

  async delete(key: string): Promise<ICacheResult<any>> {
    try {
      this.session.removeItem(key);
    } catch (e) {
      console.log('session storage delete get error', e);
    }
    return Promise.resolve(this.ResolveSuccess);
  }
}
